import { Engagement } from "@wingspanhq/wingspan-api-sdk";

export type EngagementOption = {
  label: string;
  value: string;
};

export const selectorEngagementOptions = (
  engagements: Engagement[]
): EngagementOption[] =>
  engagements
    .map(engagement => ({
      label: engagement.name,
      value: engagement.id
    }))
    .filter(
      (option): option is EngagementOption => !!option.label && !!option.value
    );
